<template>
    <div class="flex items-center">
        <div class="h-[8] bg-[#fff] rounded-[4] flex items-center relative shrink-0" :style="{ width: width, }">
            <div class="h-[8] bg-[#FD9800] rounded-[4] shrink-0" :style="{ width: percentageProgress }"></div>
            <div class="h-[8] w-[4] rounded-[4] shrink-0" v-if="Number(progress) < maxProgress && Number(progress) > 0">
            </div>
            <div class="h-[8] bg-[#DCDEE3] rounded-[4] shrink-0" :style="{ width: voidPercentageProgress }"></div>
        </div>
        <span class="t-[#303133] t-[14] ml-[4] shrink-0">{{ percentageProgress }}</span>
    </div>
</template>
<script>

export default {
    name: 'dg-progress',
    data() {
        return {
            timer: null,
            num: 0,
        }
    },
    props: {
        // 进度条长度
        width: {
            type: [Number, String],
            default: '208px',
        },
        // 最大值
        maxProgress: {
            type: [Number, String],
            default: 1,
        },
        // 原值
        progress: {
            type: [Number, String],
            default: 0,
        },
        // 背景色
        bgColor: {
            type: String,
            default: '#FF9900'
        },
        // 百分比*倍率
        percentage: {
            type: [Number, String],
            default: 100,
        },
    },
    watch: {
        progress: {
            deep: true,
            immediate: true,
            handler(newVal) {
                console.log(newVal, 'new')
                this.setPercentageProgress()
            },
        },
    },
    computed: {
        // 转化百分比
        percentageProgress() {
            // return Number(this.num) * Number(this.percentage) + '%'
            return Number(this.num) + '%'
            // return 0
        },
        // 空值百分比
        voidPercentageProgress() {
            // return (Number(this.maxProgress) - Number(this.num)) * Number(this.percentage) + '%'
            return (Number(this.maxProgress) - Number(this.num)) + '%'
            // return 0
        }
    },
    methods: {
        setPercentageProgress() {
            clearInterval(this.timer)
            this.timer = null
            // console.log(Number(this.num) * Number(this.percentage),"Number(this.num) * Number(this.percentage)")
            this.timer = setInterval(() => {
                if (this.num >= Number(this.progress * this.percentage)) {
                    clearInterval(this.timer)
                    this.timer = null
                } else {
                    this.num++
                    // console.log(this.num, "this.num")
                    // console.log((Number(this.num) * this.percentage), "Number(this.num) * Number(this.percentage)")
                }
            }, 30)
        }
    },
    create() {
        // this.setPercentageProgress()
    }
}
</script>
<style scoped lang="less">
.aui-gap {
    gap: 0 5px;
}
</style>